import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'
import { useStateValue } from '@State'
import { toast } from '@CommonComponents/toast'

const OAuthKeysSection = ({ organization }) => {
  const [, dispatch] = useStateValue()
  const [working, setWorking] = useState(false)
  const keys = organization.oauthKeys || []

  const refreshOrg = data => {
    dispatch({ type: 'selectOrg', payload: data.organization })
  }

  const addKey = async () => {
    if (working) return
    setWorking(true)
    try {
      const resp = await client.post(
        endpoints.addOAuthKey({ orgId: organization.id }),
        {}
      )
      refreshOrg(resp.data)
      toast.success('New OAuth key added.')
    } catch (err) {
      toast.error(
        `Unable to add key. ${(err.response && err.response.data && err.response.data.error) || err.message || err}`
      )
    } finally {
      setWorking(false)
    }
  }

  const toggleKey = async (keyId, nextEnabled) => {
    if (working) return
    setWorking(true)
    try {
      const resp = await client.post(
        endpoints.toggleOAuthKey({ orgId: organization.id, keyId }),
        { enabled: nextEnabled }
      )
      refreshOrg(resp.data)
    } catch (err) {
      toast.error(
        `Unable to update key. ${
          (err.response && err.response.data && err.response.data.error) || err.message || err
        }`
      )
    } finally {
      setWorking(false)
    }
  }

  return (
    <div className="mt-3">
      <h3 className="d-flex align-items-center">
        <span>OAuth Keys</span>
        <button
          type="button"
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed ml-3"
          onClick={addKey}
          disabled={working}
        >
          <i className="fa fa-plus fa-fw mr-1" /> Add Key
        </button>
      </h3>
      {keys.length === 0 ? (
        <p>No keys configured.</p>
      ) : (
        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Created</th>
              <th>Key</th>
              <th>Secret</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {keys.map(k => (
              <tr key={k.id}>
                <td>{k.createDate}</td>
                <td>
                  <code>{k.key}</code>
                </td>
                <td>
                  <code>{k.secret}</code>
                </td>
                <td>
                  {k.enabled ? (
                    <span className="label label-success">Enabled</span>
                  ) : (
                    <span className="label label-default">Disabled</span>
                  )}
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
                    onClick={() => toggleKey(k.id, !k.enabled)}
                    disabled={working}
                  >
                    {k.enabled ? 'Disable' : 'Enable'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

OAuthKeysSection.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.string.isRequired,
    oauthKeys: PropTypes.array,
  }).isRequired,
}

export default OAuthKeysSection
